import { axiosUser } from '@axios/axiosInstances';
const BRANCH_URL = `/branch`;

export const createBranch = body => axiosUser.post(`${BRANCH_URL}`, body);
export const getBranches = (query = {}) => axiosUser.get(`${BRANCH_URL}?${new URLSearchParams(query).toString()}`);
export const updateBranch = (id, body) => axiosUser.patch(`${BRANCH_URL}/${id}`, body);
export const getBranchById = id => axiosUser.get(`${BRANCH_URL}/${id}`);
